import React, { useEffect, useState } from "react";
import { useGlobal } from "../../context/GlobalContext";
import { useLocation, useNavigate } from "react-router-dom";
import { images } from "../../assets/images";

const CONDITION_COLORS = {
  danger: "#ff0000",
  poor: "#ff8c00",
  fair: "#ffd700",
  good: "#008000",
  excellent: "#0000ff",
};

const EndJobDetails = () => {
  const { getServiceDetails, submitServiceReport } = useGlobal();
  const [serviceDetails, setServiceDetails] = useState(null);
  const [scaleData, setScaleData] = useState([]);
  const [activeScale, setActiveScale] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const servicePid = location.state?.service_pid;
  const jobPid = location.state?.job_pid;
  console.log("servicePid", servicePid);

  useEffect(() => {
    if (!servicePid) return;

    const fetchData = async () => {
      const details = await getServiceDetails(servicePid, jobPid);

      setServiceDetails(details);

      if (details?.content?.length > 0) {
        const formattedData = details.content.map((item) => ({
          key: item?.condition,
          label:
            item?.condition.charAt(0).toUpperCase() + item?.condition.slice(1),
          color: item?.color || CONDITION_COLORS[item?.condition],
          title: item?.title,
          description: item?.description,
          is_selected: item?.is_selected,
        }));

        setScaleData(formattedData);

        const selectedScale = formattedData.find((item) => item.is_selected);

        setActiveScale(selectedScale || formattedData[0]);
      }
    };

    fetchData();
  }, [servicePid]);

  const handleSaveAssessment = async () => {
    if (!activeScale) return;

    const payload = {
      job_pid: jobPid,
      service_pid: servicePid,
      status: activeScale.key,
    };

    const response = await submitServiceReport(payload);

    if (response) {
      navigate(-1);
    }
  };

  const hasExistingAssessment = scaleData.some((item) => item.is_selected);

  return (
    <div className="content-wrapper-main2 ejd-center">
      <div className="content-main ejd-content-center px-3 pt-2 pb-5">
        {/* Subtitle */}
        <p className="fs-13 text-secondary mb-3">
          Score each area from <strong>Danger</strong> to{" "}
          <strong>Excellent</strong>
        </p>

        {/* Service Hero Card */}
        <div className="ejd-hero-card mb-4">
          <div className="ejd-hero-img">
            <img
              src={serviceDetails?.image || images.placeHolderImg}
              alt={serviceDetails?.name}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.placeHolderImg;
              }}
            />
          </div>
          <div className="flex-grow-1">
            <h5 className="fw-bold mb-2" style={{ color: "#0d1831" }}>
              {serviceDetails?.name}
            </h5>
            {activeScale && (
              <span
                className="ejd-current-badge"
                style={{
                  background: `${activeScale.color}20`,
                  color: activeScale.color,
                  border: `1px solid ${activeScale.color}50`,
                }}
              >
                {activeScale.label}
              </span>
            )}
          </div>
        </div>

        {/* Scale Selector */}
        {scaleData.length === 0 ? (
          <div className="content-card text-center py-5">
            <div className="mb-3">
              <i
                className="fa-regular fa-face-frown text-muted"
                style={{ fontSize: "42px" }}
              ></i>
            </div>

            <h5 className="fw-bold mb-2 text-dark">No Assessment Available</h5>

            <p className="text-secondary fs-14 mb-0">
              Assessment criteria has not been configured for this service yet.
            </p>
          </div>
        ) : (
          <>
            <div className="content-card mb-4">
              <p
                className="fw-semibold text-center mb-4"
                style={{ color: "#374151", fontSize: "14px" }}
              >
                Tap to rate condition
              </p>

              <div className="ejd-scale-track-wrapper">
                <div className="ejd-track-line" />
                <div className="ejd-scale-dots">
                  {scaleData?.map((item, index) => (
                    <button
                      key={index}
                      className="ejd-scale-btn"
                      onClick={() => setActiveScale(item)}
                    >
                      <div
                        className="ejd-dot transition-all"
                        style={{
                          backgroundColor:
                            activeScale?.key === item.key
                              ? item.color
                              : "white",
                          border: `3px solid ${
                            activeScale?.key === item.key
                              ? item.color
                              : "#d1d5db"
                          }`,
                          boxShadow:
                            activeScale?.key === item.key
                              ? `0 0 0 4px ${item.color}25`
                              : "none",
                        }}
                      />
                      <span
                        className="ejd-dot-label transition-all"
                        style={{
                          color:
                            activeScale?.key === item.key
                              ? item.color
                              : "#9ca3af",
                          fontWeight:
                            activeScale?.key === item.key ? "700" : "500",
                        }}
                      >
                        {item.label}
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Active Condition Detail */}
            {activeScale && (
              <div className="ejd-condition-card mb-4">
                <div
                  className="ejd-condition-header"
                  style={{ backgroundColor: activeScale.color }}
                >
                  <h6 className="fw-bold text-white mb-0">
                    {activeScale.title}
                  </h6>
                </div>
                <div className="ejd-condition-body">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div
                      className="ejd-criteria-icon"
                      style={{
                        backgroundColor: `${activeScale.color}15`,
                        color: activeScale.color,
                      }}
                    >
                      <i className="fa-solid fa-list-check fs-12"></i>
                    </div>
                    <span className="fw-bold text-dark fs-14">
                      Assessment Criteria
                    </span>
                  </div>
                  <div
                    className="fs-14 assessment-html"
                    dangerouslySetInnerHTML={{
                      __html: activeScale?.description || "",
                    }}
                  />
                </div>
              </div>
            )}

            {/* Save Button */}
            <div className="text-center">
              <button
                className="btn btn-primary  fw-semibold rounded-3"
                style={{ fontSize: "15px" }}
                onClick={handleSaveAssessment}
              >
                <i className="fa-solid fa-check me-2"></i>
                {hasExistingAssessment
                  ? "Update Assessment"
                  : "Save Assessment"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EndJobDetails;
